import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { PicEntity } from '../domain/pic.entity';
import { featureSelector, ProjectRootState } from './feature.store';
import { PicsSliceKey, PicsSliceState } from './pics.state';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[PicsSliceKey]
);

const PicsSelector = createSelector(baseSelector, (state) => state.all);

@Injectable()
export class PicSelector {
	public constructor(private readonly store: Store<ProjectRootState>) {}

	private get state(): Observable<PicsSliceState> {
		return this.store.pipe(select(baseSelector));
	}

	public getPics$(): Observable<Array<PicEntity>> {
		return this.store.pipe(select(PicsSelector));
	}
}
